import React from "react";

import { Box, Paper } from "@mui/material";
import { useFormContext } from "react-hook-form";

import Spacer from "@components/layout/Spacer";

import { FormValues } from "../RegisterPage";
import Footer from "./Footer";
import Header from "./Header";
import RepeatableEntryList from "./RepeatableEntryList";

interface Props {
  onPreviousStep: () => void;
}

/**
 * Step 2 — optional professional background. Education, trainings and
 * certifications share the same repeatable-list pattern, so they live together
 * on one screen instead of three near-identical steps. All sections are
 * optional: the user can finish with any of them empty.
 */
const Step2Form: React.FC<Props> = ({ onPreviousStep }) => {
  const {
    formState: { isSubmitting },
  } = useFormContext<FormValues>();

  return (
    <Paper elevation={0} square>
      <Box padding={{ xs: 3, sm: 8 }} paddingBottom={{ xs: 8, sm: 12 }}>
        <Header
          step={2}
          totalSteps={2}
          subtitle="Tell us about your background (optional)"
        />
        <Spacer pxVertical={40} />

        <RepeatableEntryList
          name="education"
          title="Education Details"
          nameLabel="Institute name"
          addLabel="Add education"
        />
        <Spacer pxVertical={32} />

        <RepeatableEntryList
          name="trainings"
          title="Trainings Attended"
          nameLabel="Training name"
          addLabel="Add training"
        />
        <Spacer pxVertical={32} />

        <RepeatableEntryList
          name="certifications"
          title="Certifications"
          nameLabel="Certificate name"
          addLabel="Add certification"
        />

        <Spacer pxVertical={40} />
        <Footer
          nextLabel="Finish"
          isSubmitting={isSubmitting}
          onBack={onPreviousStep}
          submitOnNext
        />
      </Box>
    </Paper>
  );
};

export default Step2Form;
